
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.389 5.561c1.148-2.032 4.076-2.032 5.224 0l8.415 14.9c1.13 2-.315 4.476-2.612 4.476H6.586c-2.298 0-3.743-2.476-2.613-4.476l8.416-14.9z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M15.863 11.007h-1.72l.135 6.483h1.448l.136-6.483zM15 20.192c.57 0 1.045-.396 1.045-.889 0-.484-.475-.884-1.045-.884-.575 0-1.046.4-1.046.884 0 .493.47.889 1.046.889z","fill":"#fff"}})])
          )
        }
      }
    